<template>
  <div>
    <k-layout v-for="lang in val" :key="lang.lang">
      <k-flex :style="{'align-self': (multiLine || markdown ? 'flex-end' : 'initial')}" c1>
        <k-autocomplete :items="languages" v-model="lang.lang" label="Lang" :disabled="languagesIsEmpty"></k-autocomplete>
      </k-flex>
      <k-flex c9>
        <MarkDown
          v-if="markdown"
          v-model="lang.value"
          :label="label || title"
          style="margin-left: 10px;"
        ></MarkDown>
        <k-text-field textarea
          v-else-if="multiLine"
          v-model="lang.value"
          :label="label || title"
        ></k-text-field>
        <k-text-field
          v-else
          v-model="lang.value"
          :label="label || title"
        ></k-text-field>
      </k-flex>
      <k-flex c2 class="text-xs-right">
        <k-btn color="danger" icon @click.stop="removeLanguage(lang.lang)" :disabled="removeDisabled" icon-name="delete"></k-btn>
      </k-flex>
    </k-layout>
    <div class="text-xs-right">
      <k-btn size="xs" color="primary" small :disabled="languagesIsEmpty" @click="addLanguage">Add language</k-btn>
    </div>
  </div>
</template>

<script>
import MarkDown from "@/components/MarkDown"
export default {
  components: {
    MarkDown
  },
  props: {
    'value': {
      type: Object,
      default () { return {}; }
    },
    'languages': {
      type: Array,
      default () { return []; }
    },
    'default_language': {
      type: String,
      default: "en"
    },
    'label': String,
    'title': String,
    'name': String,
    'multi-line': {
      type: Boolean,
      default: false
    },
    'markdown': {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.val.length == 0 && this.languages.indexOf(this.default_language) != -1) {
        this.val.push({"lang": this.default_language, "value": ""})
      }
    })
  },
  computed: {
    languagesIsEmpty () {
      return this.usedLanguages.length == 0;
    },
    removeDisabled () {
      if (this.val.length == 1) return true;
      return false;
    },
    usedLanguages () {
      var usedLangs = this.val.map((item) => { return item.lang; });
      return this.languages.filter((item) => {
        return usedLangs.indexOf(item) == -1;
      });
    },
    val: {
      get () {
        var val = _.get(this.value, this.name);
        if(typeof(val) != "object") {
          this.val = [];
          return [];
        }
        return val;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  },
  methods: {
    removeLanguage(lang) {
      var list = _.cloneDeep(this.val);
      _.remove(list, function(t) { if (t.lang == lang) return true;
        return false;
      });
      this.val = list;
    },
    addLanguage() {
      this.val.push({lang: this.usedLanguages[0]||this.default_language, value: ""});
    }
  }
}
</script>
